import Cookies from 'js-cookie'

const state = {
  device: 'desktop',
  cacheData: null
}

const mutations = {
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  CACHE_DATA: (state, data) => {
    state.cacheData = data
  },
}

const actions = {
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  cacheData({ commit }, data) {
    commit('CACHE_DATA', data)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
